<script>
import axios from "axios";
import { RAW_MATERIAL_PATH, VENDORS_PATH } from "../../../../path";
import Swal from "sweetalert2";
export default {
  name: "tag-raw-materials",
  props: ["vendor"],
  data() {
    return {
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      selectedrawMaterials: [],
      rawMaterials: [],
      fields: ["name", "action"],
      current_page: 1,
      current_page2: 1,
      filter: [],
      per_page: 10,
      search: "",
    };
  },
  watch: {
    current_page2() {
      this.getRawMaterials();
    },
    search() {
      this.getRawMaterials();
    },
  },
  mounted() {
    this.getVendorRawMaterials();
  },
  methods: {
    async getRawMaterials() {
      try {
        let res = await axios.get(this.base_url + RAW_MATERIAL_PATH.LIST, {
          params: {
            page: this.current_page2,
            search: this.search,
            not_in_id: this.selectedrawMaterials.map((f) => f.raw_material_id),
          },
        });
        if (res.data.status == true) {
          this.rawMaterials = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getVendorRawMaterials() {
      try {
        let res = await axios.get(
          this.base_url + VENDORS_PATH.GET_VENDOR_RAW_MATERIALS,
          {
            params: {
              vendor_id: this.vendor.id,
            },
          }
        );
        if (res.data.status == true) {
          this.selectedrawMaterials = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async removeRawMaterial(v) {
      try {
        let res = await axios.post(
          this.base_url + VENDORS_PATH.ATTACH_VENDOR_RAW_MATERIALS,
          {
            vendor_id: this.vendor.id,
            raw_materials: [v.raw_material_id],
          }
        );
        if (res.data.status) {
          this.selectedrawMaterials = this.selectedrawMaterials.filter(
            (f) => f.id != v.id
          );
          Swal.fire("success", "", "success");
        } else {
          throw new Error(res.data.message);
        }
      } catch (e) {
        console.log(e);
        Swal.fire(e.message, "", "error");
      }
    },
    async addRawMaterial(v) {
      try {
        let res = await axios.post(
          this.base_url + VENDORS_PATH.ATTACH_VENDOR_RAW_MATERIALS,
          {
            vendor_id: this.vendor.id,
            raw_materials: [v.id],
          }
        );
        if (res.data.status) {
          this.rawMaterials.data = this.rawMaterials.data.filter(
            (f) => f.id != v.id
          );
          Swal.fire("success", "", "success");
        } else {
          throw new Error(res.data.message);
        }
      } catch (e) {
        console.log(e);
        Swal.fire(e.message, "", "error");
      }
    },
  },
};
</script>

<template>
  <b-card>
    <b-card-body>
      <b-tabs>
        <b-tab title="Selected Raw Materials" @click="getVendorRawMaterials">
          <div class="table-responsive mb-0">
            <b-table
              :key="selectedrawMaterials"
              :items="selectedrawMaterials"
              :fields="fields"
              responsive="sm"
              :filter="filter"
              :current-page="current_page"
              :per-page="per_page"
            >
              <template v-slot:cell(name)="row">
                {{ row.item?.raw_material?.name }}
              </template>
              <template v-slot:cell(action)="row">
                <b-button
                  class="mr-2"
                  @click="removeRawMaterial(row.item)"
                  variant="danger"
                  v-b-tooltip:hover
                >
                  <i class="fa fa-minus"></i>
                </b-button>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    :key="selectedrawMaterials"
                    v-model="current_page"
                    :total-rows="selectedrawMaterials.length"
                    :per-page="per_page"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Raw Materials" @click="getRawMaterials">
          <b-input v-model="search" placeholder="search"></b-input>
          <div class="table-responsive mb-0">
            <b-table
              :key="rawMaterials.key"
              :items="rawMaterials.data"
              :fields="fields"
              responsive="sm"
              :filter="filter"
              :current-page="current_page2"
            >
              <template v-slot:cell(action)="row">
                <b-button
                  class="mr-2"
                  @click="addRawMaterial(row.item)"
                  variant="success"
                  v-b-tooltip:hover
                >
                  <i class="fa fa-plus"></i>
                </b-button>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    :key="rawMaterials.key"
                    v-model="current_page2"
                    :total-rows="rawMaterials.total"
                    :per-page="rawMaterials.perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card-body>
  </b-card>
</template>
